// Web sharing helpers: the OS share sheet (navigator.share) where available, and
// a popup for per-network intent URLs (see @goaltree/ui/lib/social-share).

export type ShareResult = 'shared' | 'unsupported' | 'error'

export function canNativeShare(file?: File): boolean {
  if (typeof navigator === 'undefined' || !navigator.share) return false
  if (file && typeof navigator.canShare === 'function') return navigator.canShare({ files: [file] })
  return true
}

export async function nativeShare(opts: {
  text: string
  url?: string
  file?: File
}): Promise<ShareResult> {
  if (typeof navigator === 'undefined' || !navigator.share) return 'unsupported'
  try {
    const withFile = opts.file && navigator.canShare?.({ files: [opts.file] })
    await navigator.share(
      withFile
        ? { text: opts.text, url: opts.url, files: [opts.file as File] }
        : { text: opts.text, url: opts.url },
    )
    return 'shared'
  } catch (e) {
    // The user dismissing the sheet rejects with AbortError — not a failure.
    if (e instanceof Error && e.name === 'AbortError') return 'shared'
    return 'error'
  }
}

export function openIntent(href: string): void {
  window.open(href, '_blank', 'noopener,noreferrer,width=600,height=640')
}
